<footer class="footer">
  <div class="content">
    <div class="row">
      <div class="col-md-6 left">Copyright ©2020 Wheel Pros, LLC.</div>
      <div class="col-md-6 right"> <a href="https://dealerline.force.com/dealerline" target="__blank">Dealerline
          Website</a></div>
    </div>
  </div>

</footer>